import {ENVIO_SMS_SEVERITIES, ENVIO_SMS_UNAVAILABLE} from './envioSmsCatalogs.js';

export const ENVIO_SMS_ANTERIOR_DEBOUNCE_MS = 500;

const COPY_FIELDS = [
  'short_description',
  'severity',
  'incident_manager',
  'affected_customer',
  'affected_services',
  'affected_equipment',
  'prevision',
  'province',
  'site',
  'communication_date',
  'communication_time',
];

/**
 * A late Comunicado anterior must not land after Enviar has started,
 * after Limpiar, or for an ID trouble ticket and Oceane the operator already left.
 */
export function shouldApplyComunicadoAnterior({
  epoch,
  requestEpoch,
  requestId,
  currentRequestId,
  sending,
  ticketId,
  queriedTicketId,
  oceane,
  queriedOceane,
}) {
  if (sending) return false;
  if (epoch !== requestEpoch) return false;
  if (requestId !== currentRequestId) return false;
  return String(ticketId ?? '').trim() === String(queriedTicketId ?? '').trim()
    && String(oceane ?? '').trim() === String(queriedOceane ?? '').trim();
}

function fieldText(value) {
  if (value == null) return '';
  const text = String(value).trim();
  if (text === ENVIO_SMS_UNAVAILABLE) return '';
  return text;
}

/**
 * A repeat Inicio is the mistake this fill must prevent.
 * Final and Seguimiento stay as the operator chose them.
 */
export function sequenceAfterComunicadoAnterior(sequence) {
  const value = String(sequence ?? '').trim();
  if (value === 'Final' || value === 'Seguimiento') return value;
  return 'Seguimiento';
}

/**
 * Copies the fields the Comunicado anterior owns, including fecha y hora de inicio.
 * Keys absent from `comunicado` stay as the operator left them
 * (Previsión, Provincia and Emplazamiento when the anterior is only an alarm).
 */
export function applyComunicadoAnterior(form, comunicado) {
  const next = {...form};
  if (!comunicado || typeof comunicado !== 'object') return next;
  for (const key of COPY_FIELDS) {
    if (!Object.prototype.hasOwnProperty.call(comunicado, key)) continue;
    if (key === 'severity') {
      const severity = fieldText(comunicado.severity);
      next.severity = ENVIO_SMS_SEVERITIES.includes(severity) ? severity : '';
      continue;
    }
    next[key] = fieldText(comunicado[key]);
  }
  return next;
}
